export class EditRuleBinding {
  objectTitle: string;
  objectName: string;
  objectSubName: string;
}
